// extracted by mini-css-extract-plugin
export default {"checkoutWrapper":"O8oWHg","checkoutFreeDomainRow":"Xe3o_E","checkoutFreeDomainLabel":"e5e2K4","saveBadge":"iMrHs1"};